const IDV_PATHS = ['/kyc', '/nda', '/face-auth', '/tfa', '/login'];

const IDV_REDIRECT_MAP = {
  KYC_REQUIRED: '/kyc',
  NDA_REQUIRED: '/nda',
  FACE_AUTH_REQUIRED: '/face-auth',
};

export default async function ({ app, route, redirect, store }) {
  if (!app.$auth.loggedIn || !app.$auth.user?.tfa_authenticated) {
    return;
  }

  if (
    IDV_PATHS.some((p) => route.path === p || route.path.startsWith(p + '/'))
  ) {
    return;
  }

  try {
    const hash = store.state.invalidateIdvCache;
    const res = await app.$axios.get(
      '/api/access.php' + (hash ? '?hash=' + hash : '')
    );
    const required = res.data.required;

    if (required && IDV_REDIRECT_MAP[required]) {
      return redirect(IDV_REDIRECT_MAP[required]);
    }
  } catch {
    // fail open — don't block the user if the check fails
  }
}
